module.exports = function modifyCSS(dom, css) {
  if (dom) {
    for (var key in css) {
      if (css.hasOwnProperty(key)) {
        dom.style[key] = css[key];
      }
    }
  }

  return dom;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/dom/modify-css.js
// module id = 72
// module chunks = 0 1 2